// extracted by mini-css-extract-plugin
export var fb = "store-page-module--fb--a12cf";
export var ig = "store-page-module--ig--9f879";
export var link = "store-page-module--link--5fda8";
export var mc = "store-page-module--mc--de86a";
export var sc = "store-page-module--sc--90819";
export var wrapper = "store-page-module--wrapper--0d18a";